const DEFAULT_MESSAGE = 'Не удалось переместить карточку. Попробуйте ещё раз.';

const MESSAGE_BY_KEY = {
  positionMustBePresent:
    'Не удалось определить позицию в списке. Обновите страницу и попробуйте снова.',
  listNotFound: 'Выбранный список не найден или недоступен.',
  listMustBePresent: 'Не выбран список для перемещения.',
  boardNotFound: 'Выбранная доска не найдена или нет доступа.',
  cardNotFound: 'Карточка не найдена или недостаточно прав для перемещения.',
  notEnoughRights: 'Недостаточно прав для перемещения карточки.',
};

const extractErrorKeys = (error) => {
  if (!error || typeof error !== 'object') {
    return [];
  }

  const sources = [error, error.body, error.data].filter(
    (item) => item && typeof item === 'object' && !Array.isArray(item),
  );

  const keys = [];
  sources.forEach((source) => {
    Object.keys(MESSAGE_BY_KEY).forEach((key) => {
      if (source[key]) {
        keys.push(key);
      }
    });
  });

  return keys;
};

const getCardTransferErrorMessage = (error) => {
  const keys = extractErrorKeys(error);
  if (keys.length > 0) {
    return MESSAGE_BY_KEY[keys[0]];
  }

  if (error && typeof error.message === 'string' && error.message.trim()) {
    const message = error.message.trim();
    // Не показываем технические/английские сообщения API как есть
    if (/[\u0400-\u04FF]/.test(message) && message.length < 180) {
      return message;
    }
  }

  return DEFAULT_MESSAGE;
};

export default getCardTransferErrorMessage;
